import React, { useContext, useMemo } from 'react';
import { ComponentContext } from '../../contexts';
import { SeatLabelsGenerator } from '../../utils/seat-labels-generator';
import { ceil } from '../../utils/utils';
import { SEAT_CIRCLE_DIAMETER, SEAT_SPACING, STROKE_WIDTH, SEAT_CIRCLE_RADIUS, COLORS, SHAPE_STROKE_COLOR, } from '../../constants';
import { GenericRow } from '../../generic/row';
import { GenericRowDirection } from '../../generic/row/interfaces';
import { GenericSquare } from '../../generic/square';
import { Label } from '../../generic/label';
export var Table = function (_a) {
    var definition = _a.definition, GenericRowRasterizer = _a.GenericRowRasterizer;
    var width = definition.width, height = definition.height, layout = definition.layout;
    var topSeatAmount = layout[0], rightSeatAmount = layout[1], bottomSeatAmount = layout[2], leftSeatAmount = layout[3];
    var fill = COLORS.FILL;
    var seatsReservedSize = SEAT_CIRCLE_DIAMETER + SEAT_SPACING;
    var totalSeatsSize = seatsReservedSize * 2;
    var totalBorderSize = STROKE_WIDTH * 2;
    var rectWidth = Math.max(width - totalSeatsSize + totalBorderSize, 0);
    var rectHeight = Math.max(height - totalSeatsSize + totalBorderSize, 0);
    var labelGenerator = useMemo(function () { return SeatLabelsGenerator(definition); }, [definition]);
    var _b = useContext(ComponentContext), PointerArea = _b.PointerArea, SelectionMarker = _b.SelectionMarker;
    var renderTopSeats = function () {
        var seatAmount = topSeatAmount;
        var initialContainerSize = rectWidth;
        var totalSize = width;
        var overflow = getAllowedContainerOverflow(totalSize, initialContainerSize, seatAmount);
        var containerSize = initialContainerSize + overflow;
        return (React.createElement("svg", { x: seatsReservedSize - ceil(overflow / 2), y: 1, width: containerSize, height: SEAT_CIRCLE_DIAMETER },
            React.createElement(GenericRow, { GenericRowRasterizer: GenericRowRasterizer, definition: definition, containerSize: containerSize, labelGenerator: labelGenerator, direction: GenericRowDirection.HORIZONTAL, seatAmount: seatAmount })));
    };
    var renderRightSeats = function () {
        var seatAmount = rightSeatAmount;
        var initialContainerSize = rectHeight;
        var totalSize = height;
        var overflow = getAllowedContainerOverflow(totalSize, initialContainerSize, seatAmount);
        var containerSize = initialContainerSize + overflow;
        return (React.createElement("svg", { x: seatsReservedSize + rectWidth + SEAT_SPACING - 1, y: seatsReservedSize - ceil(overflow / 2), width: SEAT_CIRCLE_DIAMETER, height: containerSize },
            React.createElement(GenericRow, { GenericRowRasterizer: GenericRowRasterizer, definition: definition, containerSize: containerSize, labelGenerator: labelGenerator, direction: GenericRowDirection.VERTICAL, seatAmount: seatAmount })));
    };
    var renderBottomSeats = function () {
        var seatAmount = bottomSeatAmount;
        var initialContainerSize = rectWidth;
        var totalSize = width;
        var overflow = getAllowedContainerOverflow(totalSize, initialContainerSize, seatAmount);
        var containerSize = initialContainerSize + overflow;
        return (React.createElement("svg", { x: seatsReservedSize - ceil(overflow / 2), y: seatsReservedSize + rectHeight + SEAT_SPACING - 1, width: containerSize, height: SEAT_CIRCLE_DIAMETER },
            React.createElement(GenericRow, { GenericRowRasterizer: GenericRowRasterizer, definition: definition, containerSize: containerSize, labelGenerator: labelGenerator, direction: GenericRowDirection.HORIZONTAL, seatAmount: seatAmount, reverse: true })));
    };
    var renderLeftSeats = function () {
        var seatAmount = leftSeatAmount;
        var initialContainerSize = rectHeight;
        var totalSize = height;
        var overflow = getAllowedContainerOverflow(totalSize, initialContainerSize, seatAmount);
        var containerSize = initialContainerSize + overflow;
        return (React.createElement("svg", { x: 1, y: seatsReservedSize - ceil(overflow / 2), width: SEAT_CIRCLE_DIAMETER, height: containerSize },
            React.createElement(GenericRow, { GenericRowRasterizer: GenericRowRasterizer, definition: definition, containerSize: containerSize, labelGenerator: labelGenerator, direction: GenericRowDirection.VERTICAL, seatAmount: seatAmount, reverse: true })));
    };
    return (React.createElement(React.Fragment, null,
        renderTopSeats(),
        renderRightSeats(),
        renderBottomSeats(),
        renderLeftSeats(),
        React.createElement(GenericSquare
        // We subtract 0.5 so that SVG would not paint between pixels causing a larger line
        , { 
            // We subtract 0.5 so that SVG would not paint between pixels causing a larger line
            x: seatsReservedSize - 0.5, y: seatsReservedSize - 0.5, width: rectWidth, height: rectHeight, fill: fill, stroke: SHAPE_STROKE_COLOR, notBounding: true }, definition.label ? (React.createElement(Label, { color: SHAPE_STROKE_COLOR, width: rectWidth, height: rectHeight, angle: definition.angle }, definition.label)) : null),
        React.createElement(SelectionMarker, { x: seatsReservedSize - 0.5, y: seatsReservedSize - 0.5, width: rectWidth, height: rectHeight }),
        React.createElement(PointerArea, { width: width, height: height })));
};
var getAllowedContainerOverflow = function (totalSize, containerSize, seatAmount) {
    var emptySpace = containerSize - seatAmount * SEAT_CIRCLE_RADIUS * 2;
    if (emptySpace >= 0) {
        return 0;
    }
    // We do not want vertical and horizontal seats to overlap
    var minDistanceFromSide = ceil(Math.sqrt(2 * Math.pow(SEAT_CIRCLE_RADIUS, 2)));
    var additionalSpace = 2;
    var overflow = totalSize - minDistanceFromSide * 2 - containerSize - additionalSpace;
    if (overflow < 0) {
        return 0;
    }
    return overflow;
};
//# sourceMappingURL=table.js.map